import Tag from '../components/tag'

const Me = () => {
    return <div className="flex flex-col md:flex-row gap-6 md:items-center shadow-lg rounded-xl p-2 ">
        
        {/* img */}
        <div className="flex justify-center md:justify-start">
            <img
                src={"/github.png"}
                alt="GitHub logo"
                className="w-32 h-32 rounded-full object-cover"
            />
        </div>
        {/* info */}
        <div className="flex flex-col items-center md:items-start gap-2">
            <div className="text-2xl">Marco Michelotti</div>
            <div className="flex flex-col md:flex-row gap-2">
                <Tag>Software Engineer</Tag>
                <Tag>Data Engineer</Tag>
                <Tag>DevOps Engineer</Tag>
            </div>
        </div>

    </div>
}

export default Me